import {HttpContextToken, HttpErrorResponse} from '@angular/common/http';

export const SKIP_CANCEL_ON_NAV = new HttpContextToken<boolean>(() => false);

// Only the primary read of a page handles its 403/404 without a toast.
export const RESOURCE_PAGE_REQUEST = new HttpContextToken<((error: HttpErrorResponse) => void) | null>(() => null);
